<template>
    <div class="kbet-custom-reset heightMAX" :style="{ overflow: 'hidden' }">
        <drop @dragover="handleBodyDragOver(...arguments)" @drop="handleBodyDrop(...arguments)" class="heightMAX">
            <div class="kbet-custom-reset">
                <!-- Compact 모드 (width 3~4) -->
                <div v-if="isCompact" class="card card--compact" :style="{ backgroundColor: getDiColor(currentDI) }">
                    <div class="card__header">
                        <div class="card__info">
                            <div class="card__title">
                                불쾌지수
                                <span class="card__tooltip" v-b-tooltip.hover :title="DItext">
                                    <i class="fas fa-exclamation"></i>
                                </span>
                            </div>
                            <div class="card__subtitle">Discomfort Index</div>
                            <div class="card__value font-roboto-slab">{{ currentDI }}</div>
                        </div>
                        <div class="card__expression">
                            <SmileyFace :mood="calcGradeDi(currentDI)" :bounceAmount="20" />
                        </div>
                    </div>
                    <div class="card__footer">
                        <div class="card__stat">
                            <span class="card__stat-label">이전</span>
                            <span class="card__stat-value">{{ prevLeftDI }}</span>
                        </div>
                        <div class="card__stat">
                            <span class="card__stat-label">비교</span>
                            <span class="card__stat-value">{{ prevRightDI }}</span>
                        </div>
                    </div>
                </div>

                <!-- 일반 모드 (width 5 이상) -->
                <div v-else class="card card--default" :style="{ backgroundColor: getDiColor(currentDI) }">
                    <div class="card__header">
                        <div class="card__title-wrap">
                            <div class="card__title">
                                불쾌지수
                                <span class="card__tooltip" v-b-tooltip.hover :title="DItext">
                                    <i class="fas fa-exclamation"></i>
                                </span>
                            </div>
                            <div class="card__subtitle">Discomfort Index</div>
                        </div>
                        <div class="card__content">
                            <div class="card__value font-roboto-slab">{{ currentDI }}</div>
                            <div class="card__expression">
                                <SmileyFace :mood="calcGradeDi(currentDI)" :bounceAmount="10" />
                            </div>
                        </div>
                    </div>
                    <div class="card__footer">
                        <div class="card__stat">
                            <span class="card__stat-label">이전</span>
                            <span class="card__stat-value">{{ prevLeftDI }}</span>
                        </div>
                        <div class="card__stat">
                            <span class="card__stat-label">비교</span>
                            <span class="card__stat-value">{{ prevRightDI }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </drop>
    </div>
</template>

<script>
import { mapState } from "vuex";
import xeBaseWidget from "@src/views/widget/v1/common/xeBaseWidget.js";
import SmileyFace from "@src/views/new/energy-total-status/building-energy-efficiency-analysis/panels/HumanExpressionPanel.vue";

export default {
    name: "xeDiscomfortIndex",
    extends: xeBaseWidget,
    components: {
        SmileyFace,
    },
    props: [],
    data() {
        return {
            currentDI: "-",
            prevLeftDI: "-",
            prevRightDI: "-",
            unit: "",
            DItext: "DI 지수는 29 이하일 시 쾌적, 30과 39 사이일 시 불편, 40 이상일 때 주의를 나타내는 지수입니다.",
        };
    },
    computed: {
        ...mapState({
            units: (state) => state.unitCodes,
        }),
        isCompact() {
            const w = Number(this.widget?.w || 6);
            return w >= 3 && w <= 4;
        },
    },
    created() {
        if (!this.widget.title) {
            this.widget.title = "불쾌지수";
        }
    },
    mounted() {},
    methods: {
        findUnit(unitSmallCode) {
            for (const key of Object.keys(this.units)) {
                const foundUnit = this.units[key].find((item) => item.value === unitSmallCode);
                if (foundUnit) {
                    return foundUnit.text;
                }
            }
            return null;
        },
        applyData(data) {
            this.currentDI = data.values.envComparison.chartData.DI.currentMonth.AVG || "-";
            this.prevLeftDI = data.values.envComparison.chartData.DI.prevMonth.AVG || "-";
            this.prevRightDI = data.values.envComparison.chartData.DI.prevYearMonth.AVG || "-";
            this.unit = data.values.envComparison.chartData.DI.unitCode;
        },
        getDiColor(val) {
            const value = Number(val);
            if (value <= 29) return "#448AFF";
            if (value <= 39) return "#FFA000";
            return "#FF5252";
        },
        calcGradeDi(val) {
            if (val <= 29) return "smile";
            if (val <= 39) return "sad";
            return "angry";
        },
    },
};
</script>

<style scoped>
/* ========================================
   공통 스타일
   ======================================== */
.card {
    width: 100%;
    height: 100%;
    border-radius: 5px;
}

.card__title {
    font-weight: 800;
    color: yellow;
    display: flex;
    align-items: center;
}

.card__subtitle {
    color: yellow;
}

.card__value {
    font-weight: 800;
    color: yellow;
}

.card__tooltip {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 18px;
    height: 18px;
    margin-left: 6px;
    border: 1px solid white;
    border-radius: 50%;
    color: white;
    font-size: 10px;
    line-height: 16px;
}

.card__stat-label {
    color: white;
    font-weight: 700;
}

.card__stat-value {
    background-color: white;
    border-radius: 15px;
    font-weight: 700;
    color: #616161;
    display: flex;
    justify-content: center;
    align-items: center;
}

/* ========================================
   Compact 모드 (width 3~4)
   ======================================== */
.card--compact {
    padding: 4px 6px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.card--compact .card__header {
    display: flex;
    align-items: center;
    gap: 8px;
}

.card--compact .card__info {
    flex: 1;
    display: flex;
    flex-direction: column;
}

.card--compact .card__title {
    font-size: 12px;
}

.card--compact .card__subtitle {
    font-size: 9px;
    opacity: 0.8;
}

.card--compact .card__value {
    font-size: 18px;
}

.card--compact .card__expression {
    flex-shrink: 0;
    transform: scale(0.8);
}

.card--compact .card__tooltip {
    width: 12px;
    height: 12px;
    font-size: 7px;
    line-height: 10px;
    margin-left: 2px;
}

.card--compact .card__footer {
    display: flex;
    justify-content: space-between;
    gap: 4px;
    padding-top: 4px;
    border-top: 1px solid rgba(255, 255, 255, 0.2);
}

.card--compact .card__stat {
    width: 48%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1px;
}

.card--compact .card__stat-label {
    font-size: 9px;
    font-weight: 600;
}

.card--compact .card__stat-value {
    width: 90%;
    font-size: 11px;
    padding: 2px 4px;
    border-radius: 4px;
}

/* ========================================
   일반 모드 (width 5 이상)
   ======================================== */
.card--default {
    padding: 10px 15px;
}

.card--default .card__header {
    width: 100%;
    height: 50%;
    display: flex;
    justify-content: space-between;
}

.card--default .card__title-wrap {
    width: 50%;
}

.card--default .card__title {
    font-size: 20px;
}

.card--default .card__content {
    display: flex;
    align-items: flex-start;
}

.card--default .card__value {
    font-size: 25px;
    margin-right: 17px;
}

.card--default .card__expression {
    display: flex;
    align-items: flex-start;
}

.card--default .card__footer {
    width: 100%;
    height: 50%;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.card--default .card__stat {
    width: 45%;
    height: 70%;
    display: flex;
}

.card--default .card__stat:last-child {
    width: 47%;
}

.card--default .card__stat-label {
    width: 35%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1rem;
}

.card--default .card__stat-value {
    width: 60%;
    height: 100%;
    font-size: 1rem;
}
</style>
